import angular from 'angular';
import AuthService from './services/authService';
import Navbar from './navbar/navbar';
import Navbar2 from './navbar2/navbar2';
import AppConfig from '../../../CarsNowAppConfig';
import AuthInterceptorService from './services/authInterceptorService';
import LoadingService from './services/loadingService';
import LookupService from './services/lookupService';
import PushService from './services/pushService';
import NotificationService from './services/notificationService';
import AddPromiseService from './services/addPromiseService';
import AddEditEnquiryExtraService from './services/addEditEnquiryExtraService';
import AddEditFinancialProductService from './services/addEditFinancialProductService';
import UtilsService from './services/utilsService';
import PrintService from './services/print.service';
import ExportService from './services/export.service';
import MailService from './services/mail.service';
import AdminService from './services/admin.service';
import FileService from './services/file.service';
import BrandingService from './services/branding.service';
import PerformanceManagementService from './services/performanceManagementService';
import IntegrationService from './services/integration.service';
import CustomFormsService from './services/customForms.service';
import BarChart from './charting/barChart/barChart';
import DialogService from './services/dialogService';

let commonModule = angular.module('app.common', [
  Navbar,
  Navbar2,
  BarChart
])

.service('authService', AuthService)

.service('authInterceptorService', AuthInterceptorService)

.service('loadingService', LoadingService)

.service('lookupService', LookupService)

.service('pushService', PushService)

.service('notificationService', NotificationService)

.service('addPromiseService', AddPromiseService)

.service('addEditEnquiryExtraService', AddEditEnquiryExtraService)

.service('addEditFinancialProductService', AddEditFinancialProductService)

.service('utilsService', UtilsService)

.service('printService', PrintService)

.service('exportService', ExportService)

.service('mailService', MailService)

.service('adminService', AdminService)

.service('fileService', FileService)

.service('brandingService', BrandingService)

.service('performanceManagementService', PerformanceManagementService)

.service('integrationService', IntegrationService)

.service('customFormsService', CustomFormsService)

.service('dialogService', DialogService)

.config($httpProvider => {
  "ngInject";
  $httpProvider.interceptors.push('authInterceptorService');
})

.constant('appConfig', APP_CONFIG)

.name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js